import api from "@/lib/api";

export default {
  urlCreate: "/api/v1/stock/case/create",
  urlUpdate: "/api/v1/stock/case/update",
  urlDelete: "/api/v1/stock/case/delete",
  urlGetById: "/api/v1/stock/case/get-by-id",
  urlGetAll: "/api/v1/stock/case/get-all",
  urlSelectAll: "/api/v1/stock/case/select-all",

  async create(model) {
    const response = await api.post(this.urlCreate, model);
    return response.data;
  },
  async update(model) {
    const response = await api.put(this.urlUpdate, model);
    return response.data;
  },
  async remove(ids) {
    const params = { ids: Array.isArray(ids) ? ids.join(",") : ids };
    const response = await api.delete(this.urlDelete, { params });
    return response.data;
  },
  async getById(id) {
    const response = await api.get(this.urlGetById, { params: { id } });
    return response.data;
  },
  async getAll(params) {
    const response = await api.get(this.urlGetAll, { params });
    return response.data;
  },
  async selectAll() {
    const response = await api.get(this.urlSelectAll);
    return response.data;
  },
};